import React from 'react';
import { CheckIcon } from 'lucide-react';
import { summaryRows } from '../data/summary';
import { price } from '../data/offer';
export function SummaryTable() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-235" data-mp="o69odcht4njj">
      <div className="mx-auto max-w-4xl px-4" data-id="element-236" data-mp="o4713081h8ii">
        <h2 id="summary-title" className="text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-237" data-mp="j7yfb3zc6h2d">Resumen final</h2>
        <p className="mt-3 text-center text-muted" data-id="element-238" data-mp="1gtmc3pzpf1ef">
          MEGAPACK BIBLIOTECOLOGÍA LISTO™ · 6 tomos + 4 bonos · <b className="text-deep" data-id="element-239" data-mp="1bwdr7hn68j9h">{price}</b>
        </p>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-240" data-mp="16w85ei3l1qzb">
          {summaryRows.map(([feature, detail]) => <li key={feature} className="flex gap-3 rounded-xl border border-line bg-white p-4 shadow-card" data-id="element-241" data-mp="12vxmy5ylt83k">
              <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-teal" data-id="element-242" data-mp="3ro1j2ynbvllf" />
              <p data-id="element-243" data-mp="3nkvia6izimmc">
                <b className="block text-sm text-ink" data-id="element-244" data-mp="3nkbz6mhlls6q">{feature}</b>
                <span className="text-sm text-muted" data-id="element-245" data-mp="3icwdsqnt7ujm">{detail}</span>
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}